// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E1QxlL_rgZtTRP {
  display: flex;
  position: absolute;
  top: 70px;
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  flex-direction: column;
  width: 100%;
  padding: var(--ds-space-0, 0) var(--ds-space-200, 14px) var(--ds-space-200, 14px);
  overflow: auto;
  transition: left 0.4s ease;
  background-color: var(--ds-background-input, #ffffff);
  gap: var(--ds-space-200, 14px);
}
.E1QxlL_rgZtTRP h2 {
  margin-bottom: var(--ds-space-0, 0);
}
.E1QxlL_rgZtTRP h2,
.E1QxlL_rgZtTRP h3 {
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
}
.E1QxlL_rgZtTRP p:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
.E1QxlL_rgZtTRP[data-offscreen='left'] {
  left: calc(-100vw);
}
.E1QxlL_rgZtTRP[data-offscreen='right'] {
  left: 100vw;
}
@media (prefers-reduced-motion: reduce) {
  .E1QxlL_rgZtTRP {
    transition: none;
  }
}
.fieKdT991gDjct {
  border-top: 1px solid var(--ds-border, #091e4224);
}
.fieKdT991gDjct > * {
  display: flex;
  align-items: center;
  min-height: 70px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.o__zrKZOFVDPuI {
  display: block;
}
.o__zrKZOFVDPuI > * {
  /* stylelint-disable-next-line declaration-no-important */
  padding-left: var(--ds-space-0, 0) !important;
}
.W8kNpBCepwqyKl {
  padding: var(--ds-space-300, 24px);
  background-color: var(--ds-background-accent-purple-subtlest, rgba(234, 230, 255, 0.4));
}
.W8kNpBCepwqyKl p {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
`, ""]);
// Exports
export var page = `E1QxlL_rgZtTRP`;
export var tabList = `fieKdT991gDjct`;
export var navLinkContainer = `o__zrKZOFVDPuI`;
export var secondary = `W8kNpBCepwqyKl`;
export default ___CSS_LOADER_EXPORT___;
